import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Card, CardBody } from 'reactstrap';
import { toast } from 'react-toastify';
import api from '../../api';

const BattleTowerModal = ({ isOpen, toggle, playerPos, spawnText, onAccessGranted }) => {
  const [loading, setLoading] = useState(false);
  const [selectedTower, setSelectedTower] = useState(null);

  const towerOptions = [
    {
      id: '60second',
      name: '60-Second Challenge',
      description: 'Beat as many trainers as possible in 60 seconds!',
      cost: 0, // Free to enter
      image: '/Battle/FireCave.png'
    },
    {
      id: 'endless',
      name: 'Endless Tower',
      description: 'See how many floors you can climb in this endless challenge!',
      cost: 0, // Free to enter
      image: '/Battle/green.png'
    }
  ];

  const handleTowerSelect = (tower) => {
    setSelectedTower(tower);
  };

  const handleEnterTower = async () => {
    if (!selectedTower) {
      toast.error('Please select a tower first!');
      return;
    }

    setLoading(true);
    try {
      // Call API to purchase access to the tower (free now)
      const response = await api.post('/v1/battle-tower/access', {
        tower_type: selectedTower.id,
        cost: 0 // Free to enter
      });

      // Show success message with floating text
      if (response.data.success) {
        // Spawn floating text showing tower access granted
        spawnText(`${selectedTower.name} access granted!`, playerPos.x, playerPos.y - 20, '#00ff00');
        
        // Show success toast
        toast.success(`Welcome to the ${selectedTower.name}!`);
        
        // Notify parent component that access was granted
        onAccessGranted({
          tower_type: selectedTower.id,
          expiration_time: response.data.expiration_time,
          remaining_seconds: response.data.remaining_seconds || 60
        });
        
        // Close the modal
        toggle();
      }
    } catch (error) {
      console.error('Error purchasing tower access:', error);
      const errorMsg = error.response?.data?.detail || 'Failed to purchase tower access';
      
      if (errorMsg.includes('insufficient funds')) {
        toast.error('You don\'t have enough coins!');
        spawnText('Not enough coins!', playerPos.x, playerPos.y - 20, '#ff0000');
      } else {
        toast.error(errorMsg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>Battle Tower Challenge</ModalHeader>
      <ModalBody>
        <p className="mb-4">
          Welcome to the Battle Tower! Test your skills against powerful trainers and climb to the top!
          Each tower has different challenges and rewards. Choose your challenge:
        </p>
        
        <Row>
          {towerOptions.map((tower) => (
            <Col md={4} key={tower.id}>
              <Card 
                className={`mb-3 tower-card ${selectedTower?.id === tower.id ? 'selected-tower' : ''}`}
                onClick={() => handleTowerSelect(tower)}
                style={{ 
                  cursor: 'pointer',
                  border: selectedTower?.id === tower.id ? '2px solid #ff9900' : '1px solid #ccc',
                  transform: selectedTower?.id === tower.id ? 'scale(1.05)' : 'scale(1)',
                  transition: 'all 0.2s ease'
                }}
              >
                <div className="tower-image" style={{ 
                  height: '100px', 
                  backgroundImage: `url(${tower.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }} />
                <CardBody>
                  <h5>{tower.name}</h5>
                  <p className="small">{tower.description}</p>
                  <div className="text-center mt-2">
                    <span className="badge bg-warning text-dark">
                      Cost: {tower.cost} coins
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        {/* <div className="mt-3">
          <h5>Tower Rules:</h5>
          <ul>
            <li>Progress is saved until you lose or complete the tower</li>
            <li>The 60-Second Challenge will automatically end after 60 seconds</li>
            <li>Endless Tower has no level cap but gets progressively harder</li>
            <li>All tower progress resets at midnight UTC</li>
          </ul>
        </div> */}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
        <Button 
          color="primary" 
          onClick={handleEnterTower} 
          disabled={loading || !selectedTower}
        >
          {loading ? 'Processing...' : `Enter Tower (${selectedTower?.cost || 0} coins)`}
        </Button>
      </ModalFooter>

      <style jsx>{`
        .tower-card:hover {
          box-shadow: 0 0 10px rgba(0,0,0,0.2);
        }
        .selected-tower {
          box-shadow: 0 0 15px rgba(255, 153, 0, 0.5);
        }
      `}</style>
    </Modal>
  );
};

export default BattleTowerModal;
